module.exports = __webpack_public_path__ + "img/manufacture.f3bdd22.webp";